<template>
<div class="columnFilter">
  <div class="screenStyle" v-Clickoutside="handleClose">
    <div class="el-button btnStyle" @click="handleOpen">
      <i v-show="isShow" class="el-input__icon is-reverse el-icon-caret-top"></i>
      <i v-show="!isShow" class="el-input__icon is-reverse el-icon-caret-bottom"></i>
      <div type="text" class="el-button__inner">列过滤器</div>
    </div>
    <div class="el-select-dropdown__wrap screenStyle ulWarpStyle" :class="{'ulWarpOpenUp':openDirection === 2}" v-show="isShow">
      <!-- 下拉数据 -->
      <ul class="el-select-dropdown__list ulStyle">
        <li class="el-select-dropdown__item"
          v-for="item in tableFullList" ref="filterDropLi"
          :class="groupByArr.indexOf(item) >=0 ? 'groupByList_hover' : ''">
          <el-checkbox
            v-model="currentNewFilter[item]"
            @change="changeListEvent(item)"
            class="checkboxStyle">{{columnsObject[item].label}}
          </el-checkbox>
        </li>
      </ul>
    </div>
  </div>
  <div>
    <!-- 选择按钮 -->
    <ul class="groupByList_ul">
      <li v-for="(items,index) in groupByList" class="groupByList_list"
      :key="items.label"
      @mouseenter="enterGroupByButton(index)"
      @mouseleave="resetGroupBy"
      @click="changeFilterEvent(index)">
        <el-button class="groupByList_btn"
        :class="filterCheckNum === index ? 'filter-active' : ''">{{items.label}}</el-button>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
import Clickoutside from '../../utils/clickoutside'
import { expire } from '@/utils/auth'

export default {
  name: 'columnFilter',
  directives: {
    Clickoutside
  },
  props: {
    columnsObject: Object,
    tableList: {
      type: Array,
      default: () => []
    },
    tableFullList: {
      type: Array,
      default: () => []
    },
    columnGroupBy: {
      type: Array,
      default: () => []
    }, // 筛选的分组
    openDirection: Number /* 1:默认向下展开，2：向上展开 */
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
  },
  data () {
    let currentFilter = {}
    this.tableFullList.map(item => {
      currentFilter[item] = this.tableList.indexOf(item) !== -1
    })
    const groupByList = [{label: '全部', filter: this.tableFullList}, ...this.columnGroupBy]
    return {
      isShow: false,
      iconState: '',
      currentFilter: currentFilter,
      afterChangeList: [],
      filterCheckNum: -1,
      groupByList: groupByList,
      groupByArr: []
    }
  },
  computed: {
    currentNewFilter () {
      return this.currentFilter
    }
  },
  methods: {
    handleOpen () {
      this.isShow = !this.isShow
    },
    handleClose () {
      this.isShow = false
    },
    changeListEvent () {
      this.afterChangeList = []
      for (var key in this.currentNewFilter) {
        if (this.currentNewFilter[key] === true) {
          this.afterChangeList.push(key)
        }
      }
      this.$emit('grandSonEvent', this.afterChangeList)
    },
    enterGroupByButton (index) {
      this.groupByArr = this.groupByList[index].filter
    },
    resetGroupBy () {
      this.groupByArr = []
    },
    changeFilterEvent (index) {
      this.filterCheckNum = index
      const groupByItem = this.groupByList[index].filter
      this.tableFullList.map(res => {
        this.currentNewFilter[res] = groupByItem.indexOf(res) !== -1
      })
      this.$emit('grandSonEvent', groupByItem)
    }
  }
}
</script>

<style scoped lang="sass">
.columnFilter
  width: 80%
  display: flex
.screenStyle
  width: 200px
.btnStyle
  width: 100%
  position: relative
.ulWarpStyle
  position: absolute
  z-index: 11
  max-height: 274px
  overflow: auto
  border-radius: 2px
  box-shadow: 0px 3px 5px  #d1dbe5
  border: 1px solid #d1dbe5
  margin: 5px 0px
.ulWarpOpenUp
  bottom: 40px
.ulStyle
  position: relative;
  background-color: #ffffff
.ulStyle li:hover,
.groupByList_hover
  background-color: #e4e8f1
  // background-color: #f5f4f4
.checkboxStyle
  display: block
.ulFiterList
  position: absolute
  z-index: 11
  max-height: 274px
  overflow: auto
  border-radius: 2px
  box-shadow: 0px 3px 5px  #d1dbe5
  border: 1px solid #d1dbe5
  margin: 5px 0px
.groupByList_ul
  display: flex
  align-items: center
  // justify-content: space-between
  flex-wrap: wrap
  // background: #fff
  // border-bottom: 1px solid #ddd
  padding: 0px 15px 2px
  .groupByList_btn
    // background: #f5f4f4
    // color: #989898
    margin-right: 10px
    font-size: 12px
  .groupByList_btn:hover,
  .groupByList_btn:after,
  .filter-active
    background: rgba(161, 213, 247, .2)
    border-color: #20a0ff
    // color: #fff
</style>



// WEBPACK FOOTER //
// columnFilter.vue?27a1bbb0